import * as theme from "../../theme";
import Button from "react-bootstrap/Button";
import { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import _ from "lodash";
import { BMS_ARRAY } from "../../helper/constants";
import PerfectScrollbar from "react-perfect-scrollbar";

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Paper, Box, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';

import {
    getBrokerageInformation,
    getDetailsAdmin,
    updateBMS,
    getIsUpdating
  } from "../../store/brokerage";

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        maxWidth: '800px', // Set a max width for better readability
        margin: '0 auto', // Center the form on the page
        padding: theme.spacing(3),
        boxSizing: 'border-box',
    },
    grayBox: {
      backgroundColor: theme.palette.grey[200],
      padding: theme.spacing(2),
      margin: theme.spacing(2, 0),
    },
    inputField: {
      margin: theme.spacing(1, 0),
    }
  }));

const EpicWorkflow = (props) => {
    const classes = useStyles();
    const { bmsWorkflowdetails, setBMSworkflowdetails, isLoading, bmsVendor} = props
    const QuoteyWorkFlow = [
        "",
        "Once the application is continued to be completed",
        "When user sends client hand-off link to client",
        "When the client completes hand-off process",
        "User clicks Go to Market for first time",
        "User receives quotes from external or in-house insurers",
        "User sends application to insurers through send to market process",
        "User sends client presentation",
        "User Binds ( Indication )",
        "User Binds ( Bindable )",
        "User confirms Bind (after an indication bind request is bound by insurer)",
        "User manually updates status to \"Closed - Incomplete Info\"",
        "User manually updates status to \"Closed - No insurer\"",
        "User manually updates status to \"Closed - Quoted Not interested\""

    ]
    //console.log("bmsVendor: ", bmsVendor)
    const isEpic = bmsVendor == "EPIC"
    return (
        <>
        {isEpic && !isLoading && 
        
        <div style={{height:"70vh" , overflowY:"auto"}}>
            
            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography> Farm and Commerical Setup </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicInsurerType 
                     bmsWorkflowdetails={bmsWorkflowdetails}
                     setBMSworkflowdetails={setBMSworkflowdetails}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>

            
            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>1 {QuoteyWorkFlow[1]} </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="1"
                        title={QuoteyWorkFlow[1]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>2 {QuoteyWorkFlow[2]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="2"
                        title={QuoteyWorkFlow[2]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>3 {QuoteyWorkFlow[3]} </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="1"
                        title={QuoteyWorkFlow[1]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>4 {QuoteyWorkFlow[4]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="4"
                        title={QuoteyWorkFlow[4]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>5 {QuoteyWorkFlow[5]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="5"
                        title={QuoteyWorkFlow[5]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>6 {QuoteyWorkFlow[6]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="6"
                        title={QuoteyWorkFlow[6]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>7 {QuoteyWorkFlow[7]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="7"
                        title={QuoteyWorkFlow[7]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>8 {QuoteyWorkFlow[8]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="8"
                        title={QuoteyWorkFlow[8]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>9 {QuoteyWorkFlow[9]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="9"
                        title={QuoteyWorkFlow[9]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>10 {QuoteyWorkFlow[10]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="10"
                        title={QuoteyWorkFlow[10]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>11 {QuoteyWorkFlow[11]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="11"
                        title={QuoteyWorkFlow[11]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>12 {QuoteyWorkFlow[12]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="12"
                        title={QuoteyWorkFlow[12]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel style={{'marginBottom': '1vh'}}>
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography>13 {QuoteyWorkFlow[13]}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <EpicWorkFlowPaper
                        stage="13"
                        title={QuoteyWorkFlow[13]}
                        bmsWorkflowdetails={bmsWorkflowdetails}
                        setBMSworkflowdetails={setBMSworkflowdetails}
                    ></EpicWorkFlowPaper>
                </ExpansionPanelDetails>
            </ExpansionPanel>

        </div>
        }
        </>
        
    )

}


const EpicWorkFlowPaper = (props) => {
    
    const classes = useStyles();
    const [CUopportunity, setCUopportunity] = useState("false"); // State to hold selected value
    const [CUactivity, setCUactivity] = useState("false");
    const [Clactivity, setClactivity] = useState("false");
    const [RunOnce, setRunOnce] = useState("false"); // State to hold selected value
    const handleChange = (setter) => (event) => {
      const value = event.target.value;
      setter(value); // Update state with selected value
    };
    const {bmsWorkflowdetails, setBMSworkflowdetails} = props;
    const information = useSelector(getBrokerageInformation);
    const handleOnBlur = (stage, key) => (event) => {
        // console.log(stage)
        // console.log(key)
        // console.log(event.target.value)
        setBMSworkflowdetails((prevObj) => {
            if(["true", "false"].includes(event.target.value)){
                //console.log("String tru or false")
            }
            return {
                ...prevObj,
                [stage]: {
                    // Spread the current stage object to avoid direct mutation
                    ...prevObj[stage],
                    [key]: event.target.value
                }
            };
        })
    } 
    let oppDisplay = CUopportunity == "true" ? "block": "none";
    let actDisplay = CUactivity == "true" ? "block" : "none";
    let actClDisplay = Clactivity == "true" ? "block" : "none";
      
    // Sync default value with initial state from bmsWorkflowdetails when the component mounts
    useEffect(() => {
        if(bmsWorkflowdetails?.[props.stage]?.["opprtunity"]){
            setCUopportunity("true")
        }
        if(bmsWorkflowdetails?.[props.stage]?.["activity_note"] || bmsWorkflowdetails?.[props.stage]?.["activity_code"]){
            setCUactivity("true")
        }
        if(bmsWorkflowdetails?.[props.stage]?.["activity_close_code"]){
            setClactivity("true")
        }
    }, [props.stage, bmsWorkflowdetails]);

    useEffect(() =>{
        if(!bmsWorkflowdetails[props.stage]){
            setBMSworkflowdetails(prevObj => ({
                ...prevObj,
                [props.stage]: {}
            }));

        }
    }, [props.stage, bmsWorkflowdetails])
    const brokerageConfiguration = information.otherinfo?.bms?.configuration;
    let OpportunityLossDisplay = ["11", "12", "13"].includes(props.stage) && CUopportunity == "true"  ? "block" : "none"

    return (
        <>
        { bmsWorkflowdetails[props.stage] && brokerageConfiguration &&
        <Paper className={classes.container}>
            <Typography variant="h6">{props.title}</Typography>
            <Typography variant="subtitle1">Stage {props.stage}</Typography>

            <Box mt={2}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Should this event only fire once?</FormLabel>
                    <RadioGroup row  onChange={handleChange(setRunOnce)} onBlur={handleOnBlur(props.stage, "runonce")} defaultValue={bmsWorkflowdetails?.[props.stage]?.["runonce"]}>
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                    </RadioGroup>                
                </FormControl>
            </Box>

            <Box mt={2}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">Do you want to create or update an opportunity?</FormLabel>
                    <RadioGroup row value={CUopportunity} onChange={handleChange(setCUopportunity)}>
                        <FormControlLabel value="true" control={<Radio />} label="Yes" />
                        <FormControlLabel value="false" control={<Radio />} label="No" />
                    </RadioGroup>
                    {/* <TextField style={{ display: oppDisplay }} className={classes.inputField} label="What stage do you want to update the opportunity?" fullWidth  variant="outlined" onBlur={handleOnBlur(props.stage, "opprtunity")} defaultValue={bmsWorkflowdetails?.[props.stage]?.["opprtunity"]}/>  */}
                    <Autocomplete
                        id="combo-box-demo"
                        options={brokerageConfiguration.OpportunityStages}
                        style={{ display: oppDisplay, marginBottom:"2vh" }}
                        onBlur={handleOnBlur(props.stage, "opprtunity")} 
                        defaultValue={bmsWorkflowdetails?.[props.stage]?.["opprtunity"]}
                        // getOptionLabel={(option) => option.title}
                        // style={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="What stage do you want to update the opportunity?" variant="outlined" />}
                    />
                    <Autocomplete
                        id="combo-box-demo"
                        options={brokerageConfiguration.OpportunityLostReasons}
                        style={{ display: OpportunityLossDisplay, marginTop:"2vh" }}
                        onBlur={handleOnBlur(props.stage, "opprtunity_loss_reason")} 
                        defaultValue={bmsWorkflowdetails?.[props.stage]?.["opprtunity_loss_reason"]}
                        // getOptionLabel={(option) => option.title}
                        // style={{ width: 300 }}
                        renderInput={(params) => <TextField {...params} label="Opportunity Loss Reason (if applicable)" variant="outlined" />}
                    />
                </FormControl>
            </Box>
            <Box mt={2}>
                <FormControl component="fieldset">
                <FormLabel component="legend">Do you want to create or update an activity?</FormLabel>
                <RadioGroup row  value={CUactivity} onChange={handleChange(setCUactivity)}>
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
                {/* <TextField style={{ display: actDisplay }} className={classes.inputField} label="What activity code do you want to use?" fullWidth   onBlur={handleOnBlur(props.stage, "activity_code")} defaultValue={bmsWorkflowdetails?.[props.stage]?.["activity_code"]} /> */}
                <Autocomplete
                    id="combo-box-demo"
                    options={brokerageConfiguration.ActivityCodes}
                    style={{ display: actDisplay, marginTop:"2vh" }}
                    onBlur={handleOnBlur(props.stage, "activity_code")} 
                    defaultValue={brokerageConfiguration.ActivityCodes.find( x => x.Code == bmsWorkflowdetails?.[props.stage]?.["activity_code"])}
                    getOptionLabel={(option) => option.Code}
                    // style={{ width: 300 }}
                    renderInput={(params) => 
                        <TextField {...params} 
                            label="What activity code do you want to use?" 
                            variant="outlined" 
                        />
                    }
                />
                <TextField style={{ display: actDisplay }} className={classes.inputField} label="What note do you want to add?"  fullWidth  onBlur={handleOnBlur(props.stage, "activity_note")} defaultValue={bmsWorkflowdetails?.[props.stage]?.["activity_note"]} />
                </FormControl>
            </Box>

            <Box mt={2}>
                <FormControl component="fieldset">
                <FormLabel component="legend">Do you want to close an activity?</FormLabel>
                <RadioGroup row value={Clactivity} onChange={handleChange(setClactivity)}>
                    <FormControlLabel value="true" control={<Radio />} label="Yes" />
                    <FormControlLabel value="false" control={<Radio />} label="No" />
                </RadioGroup>
                {/* <TextField style={{ display: actClDisplay }} className={classes.inputField} label="What activity code do you want to use?"  fullWidth  variant="outlined" onBlur={handleOnBlur(props.stage, "activity_close_code")}/> */}
                <Autocomplete
                    id="combo-box-demo"
                    options={brokerageConfiguration.ActivityCodes}
                    style={{ display: actClDisplay, marginTop:"2vh" }}
                    onBlur={handleOnBlur(props.stage, "activity_close_code")} 
                    defaultValue={brokerageConfiguration.ActivityCodes.find( x => x.Code == bmsWorkflowdetails?.[props.stage]?.["activity_close_code"])}
                    getOptionLabel={(option) => option.Code}
                    // style={{ width: 300 }}
                    renderInput={(params) => 
                        <TextField {...params} 
                            label="What activity code do you want to use?" 
                            variant="outlined" 
                        />
                    }
                />
                <TextField style={{ display: actClDisplay }} className={classes.inputField} label="What note do you want to add?" fullWidth onBlur={handleOnBlur(props.stage, "activity_close_note")} defaultValue={bmsWorkflowdetails?.[props.stage]?.["activity_close_note"]}/>
                </FormControl>
            </Box>
            <Box mt={2}>
                <FormControl component="fieldset">
                <FormLabel component="legend">Do you want to update stage of policy?</FormLabel>
                <Autocomplete
                  id="combo-box-demo"
                  options={brokerageConfiguration.PolicyStatuses}
                  style={{ display: 'block', marginTop:"2vh" }}
                  onBlur={handleOnBlur(props.stage, "policy_status")} 
                  defaultValue={bmsWorkflowdetails?.[props.stage]?.["policy_status"]}
                  getOptionLabel={(option) => option.Code}
                  // style={{ width: 300 }}
                  renderInput={(params) => 
                      <TextField {...params} 
                          label="Update Policy Status?" 
                          variant="outlined" 
                      />
                  }
                />
                </FormControl>
            </Box>
        </Paper>
        }
        </>
           )
}

const EpicInsurerType = (props) => {
  const information = useSelector(getBrokerageInformation);
  let { bmsWorkflowdetails, setBMSworkflowdetails }  = props;
  const brokerageConfiguration = information.otherinfo?.bms?.configuration;
  console.log()
  let policyLineCodes = brokerageConfiguration?.PoliciesAndLineTypes?.map(x => x.Code);
  
  const handleBlur = (stage, key) => (event) => {
    setBMSworkflowdetails((prevObj) => {
      return {
        ...prevObj,
        [stage]: {
          // Spread the current stage object to avoid direct mutation
          ...prevObj[stage],
          [key]: event.target.value
        }
      };
    })
  }
  
  return (
    <div>
      <Autocomplete
        id="combo-box-demo"
        options={policyLineCodes}
        style={{  marginTop:"2vh", width:"14rem" }}
        onBlur={handleBlur("0", "Commercial")} 
        defaultValue={bmsWorkflowdetails["0"]?.Commercial}
        // getOptionLabel={(option) => option.title}
        // style={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Commercial " variant="outlined" />}
      />

      <Autocomplete
        id="combo-box-demo"
        options={policyLineCodes}
        style={{  marginTop:"2vh" }}
        onBlur={handleBlur("0", "Farm")} 
        defaultValue={bmsWorkflowdetails["0"]?.Farm}
        // getOptionLabel={(option) => option.title}
        // style={{ width: 300 }}
        renderInput={(params) => <TextField {...params} label="Farm " variant="outlined" />}
      />
    </div>
)
}

export default EpicWorkflow;